// extracted by mini-css-extract-plugin
export default {"splashWrapper":"splash_splashWrapper__VpSTZ","splashContainer":"splash_splashContainer__4myTE"};